import { DateTime } from 'luxon'

export default {
  campaign: (state) => state.campaign,
  searchedProducts: (state) => state.searchedProducts,
  importedProducts: (state) => state.importedProducts,
  searchProductsValue: (state) => state.searchProductsValue,
  daysOnOffers: (state) => state.daysOnOffers,
  loadingAction: (state) => state.loadingAction,
  campaignDays: (state) => {
    const { initial_date, final_date } = state.campaign
    const formattedInitialDate = DateTime.fromISO(initial_date)
    const formattedFinalDate = DateTime.fromISO(final_date)
    if (formattedInitialDate.isValid && formattedFinalDate.isValid) {
      return formattedFinalDate.diff(formattedInitialDate, 'days').days + 1
    } else {
      return 0
    }
  },
  campaignVariablesConfiguration: (state) => state.campaignVariablesConfiguration?.channels,
  previousOfferSchedules: (state) => state.previousOfferSchedules,
  getVariableCharCount: (state) => (variableName) => {
    return state.variablesCharCount[variableName] || 0
  },
  channelsCharCount: (state) => state.channelsCharCount,
  getChannelCharCount: (state) => (channel, field, offerType) => {
    return (
      state.channelsCharCount?.[channel]?.[field]?.[offerType] || {
        repeatableCharCount: 0,
        validityCharCount: 0,
      }
    )
  },
  activeDispatchPanel: (state) => state.activeDispatchPanel,
}
